export enum LivePollType {
  QUIZ = 0,
  POLL = 1,
}
